import { render, staticRenderFns } from "./ReplicantiGalaxyButton.vue?vue&type=template&id=739c134d&scoped=true&"
import script from "./ReplicantiGalaxyButton.vue?vue&type=script&lang=js&"
export * from "./ReplicantiGalaxyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739c134d",
  null
  
)

export default component.exports